import React from 'react';

import { TopAsset } from '@kaltura-ott/tvpil-shared/lib/rhino/data/topAssets/types';

import { RAIL_PAGE_SIZE, WIDGET_TYPE } from 'consts';
import WidgetProvider from 'context/widgetProvider/widgetProvider';

import { RailProvider } from '../components/RailProvider';
import RailSkeleton from '../components/RailSkeleton/RailSkeleton';

import TopRailContainer from './components/TopRailContainer/TopRailContainer';
import { useTopRail } from './hooks/useTopRail/useTopRail';

interface Props {
  referenceId: string;
}

function TopRail({ referenceId }: Props) {
  const { data, settings, isRailEmpty, shouldPreventDisplay, handleSkeletonRef } = useTopRail(referenceId);
  const type = WIDGET_TYPE.COLLECTION;

  if (!settings || isRailEmpty) {
    return null;
  }

  if (shouldPreventDisplay || !data.items.length) {
    return (
      <RailSkeleton handleRef={handleSkeletonRef} settings={settings} numberOfCells={RAIL_PAGE_SIZE} shouldShowHeader />
    );
  }

  return (
    <WidgetProvider<TopAsset> type={type} settings={settings} data={data}>
      <RailProvider hasAssetsMarkedByNumber referenceId={referenceId}>
        <TopRailContainer />
      </RailProvider>
    </WidgetProvider>
  );
}

export default TopRail;
